import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolicyBeneficiaries = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "policyBeneficiaries",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16868",
		"data-name": "Group 16868",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12506",
				"data-name": "Path 12506",
				d: "M12.469,3.023a3.492,3.492,0,1,1-4.938,0,3.492,3.492,0,0,1,4.938,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12507",
				"data-name": "Path 12507",
				d: "M14.363,12.8A11.938,11.938,0,0,0,10,11.991c-4.048,0-8,1.967-8,4.992v1a1,1,0,0,0,1,1h9.413",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12508",
				"data-name": "Path 12508",
				d: "M17,22a5,5,0,0,1-5-5,5.077,5.077,0,0,1,5-5,5,5,0,0,1,0,10",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12509",
				"data-name": "Path 12509",
				d: "M17.986,15.25A1.448,1.448,0,0,1,19.4,16.689c0,1.408-2.357,2.561-2.4,2.561s-2.4-1.153-2.4-2.561a1.448,1.448,0,0,1,1.414-1.439,1.3,1.3,0,0,1,.986.428,1.3,1.3,0,0,1,.986-.428Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12510",
		"data-name": "Path 12510",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgPolicyBeneficiaries;
